import { toList } from '../../../../commons/utils';
import {
  PAYROLL_STATUS,
  PAYROLL_TYPE,
} from '../../../../commons/constants/payroll';

export const payrollTypeOpts = toList(PAYROLL_TYPE);
export const payrollStatusOpts = toList(PAYROLL_STATUS);
